import React, { useEffect } from 'react';
import { message } from 'antd';
import 'antd/dist/antd.css';
import './App.css';
import { NavBar } from './components/Header/Navbar/NavBar';
import { ImageToPdfNew } from './pages/image-to-pdf/ImageToPdfNew';
import { Welcome } from './components/Welcome/Welcome';
import { PdfEncrypt } from './pages/pdf-encrypt/PdfEncrypt';
import { PdfEncryptWrapper } from './components/PdfEncrypt/EncryptWrapper';
import { Footer } from 'antd/lib/layout/layout';
import {
	BrowserRouter,
	Route,
	Router,
	Switch,
	Redirect
} from 'react-router-dom';
import { ToolsList } from './pages/tools-list/ToolsList';

function App() {
	// useEffect(() => {
	// 	let online = navigator.onLine;
	// 	console.log(online);
	// 	if (!online) {
	// 		message.warning('You are in offline mode', 5);
	// 	} else {
	// 		message.success('online mode', 5);
	// 	}
	// }, []);
	return (
		<div>
			<NavBar></NavBar>
			<Welcome />
			{/* <PdfEncrypt /> */}
			{/* <ToolsList /> */}

			<ImageToPdfNew />
			<PdfEncryptWrapper />

			{/* <ImageToPdf /> */}
			<Footer />
		</div>
	);
}

export default App;
